import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { optionalTranslate } from '@language';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { FormSelectOption } from '../../../../../form-controls/entities/form-select-option.entity';
import { toFormSelectOption } from '../../../../../form-controls/helpers/form-select-option-helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-enum-readonly-field',
    templateUrl: './enum-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShEnumReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent implements OnDestroy {
    public translatedValue$: ReplaySubject<FormSelectOption | null> = new ReplaySubject<FormSelectOption | null>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const value: string | null = this.fieldHelper.getEnumFieldValue(profileField.FieldDefinition, record);

        if (value) {
            const translatedValue: FormSelectOption = toFormSelectOption(
                value,
                optionalTranslate(this.translateService, profileField.FieldDefinition.FlatKey, value)
            );
            this.translatedValue$.next(translatedValue);
        } else {
            this.translatedValue$.next(null);
        }
    }

    ngOnDestroy() {
        this.translatedValue$.complete();

        super.ngOnDestroy();
    }
}
